import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { EstacaoService } from 'src/app/shared/services/estacao.service';

@Component({
  selector: 'app-selecao-automatica',
  templateUrl: './selecao-automatica.component.html',
  styleUrls: ['./selecao-automatica.component.scss'],
})
export class SelecaoAutomaticaComponent implements OnInit {
  private prefixoRota: string;
  private isDesktop: boolean;
  isHybrid = false;

  constructor(
    private navParams: NavParams,
    private platform: Platform,
    private router: Router,
    private estacaoService: EstacaoService,
    private modalCtrl: ModalController) { }

  ngOnInit() {
    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');
    this.prefixoRota = this.isDesktop ? '' : '/tabs';
    this.isHybrid = this.platform.is('hybrid');
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
